import React from 'react';
import SEOHelmet from '../SEOHelmet';

interface InfoPageSEOProps {
  title: string;
  description: string;
  keywords: string[];
}

/**
 * Reusable SEO wrapper for informational pages
 * Adds common keywords and uses the SEOHelmet component
 * 
 * Usage: Import and use directly in info page components
 * 
 * Example:
 * import { InfoPageSEO } from '../utility/InfoPageSEO';
 * 
 * <InfoPageSEO 
 *   title="Shipping Info"
 *   description="Learn about our shipping..."
 *   keywords={['shipping', 'delivery']}
 * />
 */
export const InfoPageSEO: React.FC<InfoPageSEOProps> = ({ title, description, keywords }) => (
  <SEOHelmet
    title={title}
    description={description}
    keywords={[
      ...keywords,
      'senior shopping service',
      'assisted living',
      'nursing home'
    ]}
  />
);

